import { MessagesModalGeneric } from './MessagesModalGeneric'

import PhoneIcon from './IconsComponents/PhoneIcon'
import { Trans, useTranslation } from 'react-i18next'

const MessagesModal = ({
  isOpen,
  startDate,
  endDate,
  permissionsDenied,
  onClose,
  token,
  brand,
  language,
}: {
  isOpen: boolean
  startDate: string
  endDate: string
  isFirstAttempt?: boolean
  permissionsDenied?: boolean
  onClose: () => void
  token?: string
  brand: string
  language?: string
}) => {
  const { t } = useTranslation()

  const modal2Description = () => (
    <div>
      <p className="font-bold text-[20px] leading-7 text-generic-neutral-900 font-aeonik">
        <Trans i18nKey="zoom.noCamModal.subtitle" />
      </p>
      <p className="text-[20px] mb-4 leading-7 text-generic-neutral-900 font-aeonik">
        <Trans i18nKey="zoom.noCamModal.text" />
      </p>
      <div className="flex justify-center items-center mb-2">
        <p className="text-[20px] leading-7 text-generic-neutral-900 font-aeonik">
          <Trans i18nKey="zoom.noCamModal.tel" />
        </p>
      </div>
    </div>
  )
  return (
    isOpen &&
    permissionsDenied && (
      <MessagesModalGeneric
        onClose={onClose}
        description={modal2Description()}
        title={t('zoom.noCamModal.title')}
        className="text-generic-neutral-900 font-aeonik"
      >
        <div className="flex items-center justify-center gap-4 mb-2 text-generic-neutral-900 font-aeonik">
          <PhoneIcon brand={brand} />
          <p className="text-center text-[36px]">
            <Trans i18nKey="zoom.noCamModal.phone" />
          </p>
        </div>
        <div className="flex flex-col items-center justify-center text-generic-neutral-900 font-aeonik">
          <p className="text-center">
            <Trans i18nKey="zoom.noCamModal.time" />
          </p>
          <p className="text-center">
            <Trans i18nKey="zoom.noCamModal.days" />
          </p>
          <p className="text-center mt-4">
            <Trans i18nKey="zoom.noCamModal.footerNoCam" />{' '}
            <a
              href={`/zoom/instrucciones/${token}?brand=${brand}&language=${language}&start_date=${startDate}&end_date=${endDate}`}
              rel="noopener noreferrer"
              style={{ color: brand === 'vidacaixa' ? '#007EAE' : '#004039' }}
              className="underline"
              onClick={() => localStorage.removeItem('permissionsDenied')}
            >
              <Trans i18nKey="zoom.noCamModal.footerNoCamLink" />
            </a>
          </p>
        </div>
      </MessagesModalGeneric>
    )
  )
}

export default MessagesModal
